import { ItemsViewLayout } from '@app/components/items-view-layout-switch/ItemsViewLayoutSwitch';
import { StationStatusListItem } from '@app/modules/logger/screens/status/types';
import {
  favoritesSectionMessage,
  groupSectionMessage,
  myStationsSectionMessage,
  sharedStationsSectionMessage,
} from '@app/modules/logger/screens/status/status-section-messages';
import { useState } from 'react';
import { StatusViewProvider } from '../../../context/StatusViewContext';
import { useStatusSections } from '../../../hooks/useStatusSections';
import { NoStationsFoundMessage } from '../../NoStationsFoundMessage';
import { StatusSection } from './StatusSection';

interface StatusLayoutProps {
  statuses: StationStatusListItem[];
  variant?: ItemsViewLayout;
}

/**
 * Layout for station status sections and empty state.
 * Order: favorites, own stations, individually shared stations, then shared groups by name.
 */
export function StatusLayout({ statuses, variant = 'gridNormal' }: StatusLayoutProps) {
  const [itemWidth, setItemWidth] = useState(0);

  const {
    favorites,
    ownStations,
    individuallySharedStations,
    sharedGroupSections,
    hasVisibleStations,
  } = useStatusSections(statuses);

  const content = !hasVisibleStations ? (
    <NoStationsFoundMessage />
  ) : (
    <>
      <StatusSection
        items={favorites}
        variant={variant}
        onItemWidthChange={setItemWidth}
        message={favoritesSectionMessage}
      />
      <StatusSection
        items={ownStations}
        variant={variant}
        onItemWidthChange={setItemWidth}
        message={myStationsSectionMessage}
      />
      <StatusSection
        items={individuallySharedStations}
        variant={variant}
        onItemWidthChange={setItemWidth}
        message={sharedStationsSectionMessage}
      />
      {sharedGroupSections.map((section) => (
        <StatusSection
          key={section.group.id}
          items={section.items}
          variant={variant}
          onItemWidthChange={setItemWidth}
          message={groupSectionMessage}
          values={{ name: section.group.name }}
        />
      ))}
    </>
  );

  return (
    <StatusViewProvider compact={variant !== 'list'} itemWidth={itemWidth}>
      {content}
    </StatusViewProvider>
  );
}
